<template>
    <div id="calculadora">
        <v-app>
            <v-content>
                <v-container grid-list-xl>
                    <v-stepper v-model="step"
                               alt-labels
                               class="elevation-0 grey lighten-5">
                        <v-stepper-header class="elevation-0">
                            <v-stepper-step :complete="step > 1" step="1">Cadastro do cliente</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="step > 2" step="2">Características básicas do projeto</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="step > 3" step="3">Seleção do gerador</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="step > 4" step="4">Informações comerciais</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step :complete="step > 5" step="5">Resumo do projeto</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content :key="1" :step="1">
                                <ProjectClientData />
                            </v-stepper-content>
                            <v-stepper-content :key="2" :step="2">
                                <ProjectBasicCharacteristics />
                                <div class="text-center">
                                    <v-btn outline
                                           color="#021746"
                                           @click="previousStep()"
                                           class="back-button">VOLTAR</v-btn>
                                    <v-btn color="#0083CA" class="white--text" @click="nextStep()">
                                        VER GERADORES COMPATÍVEIS
                                    </v-btn>
                                </div>
                            </v-stepper-content>
                            <v-stepper-content :key="3" :step="3">
                                <ListCompatibleGenerators type="create" />
                            </v-stepper-content>
                            <v-stepper-content :key="4" :step="4">
                                <ProjectCommercialInformation ref="projectCommercialInformationRef"
                                                              v-on:validated="validated" />
                                <div class="text-center">
                                    <v-btn outline
                                           color="#021746"
                                           @click="previousStep()"
                                           class="back-button">VOLTAR</v-btn>
                                    <v-btn color="#0083CA"
                                           class="white--text"
                                           @click="validarStep()">
                                        CONFIRMAR INFORMAÇÕES
                                    </v-btn>
                                </div>
                            </v-stepper-content>
                            <v-stepper-content :key="5" :step="5">
                                <ProjectSummary />
                                <div class="text-center">
                                    <v-layout>
                                        <v-flex>
                                            <v-btn outline
                                                   color="#021746"
                                                   @click="previousStep()"
                                                   class="back-button">VOLTAR</v-btn>
                                            <v-btn color="#0083CA"
                                                   class="white--text"
                                                   @click="saveProject()">SALVAR PROJETO</v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout align-center justify-center>
                                        <v-dialog v-model="dialog" persistent max-width="500px">
                                            <v-card>
                                                <v-card-title>
                                                    <v-flex xs12>
                                                        <h3 class="primary-color text-center">
                                                            Projeto <b>{{ this.projeto.id }}</b> salvo
                                                        </h3>
                                                    </v-flex>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-flex xs12>
                                                        <p class="text-center grey--text text--darken-2">
                                                            O que deseja fazer?
                                                        </p>
                                                    </v-flex>
                                                    <v-flex class="text-center" xs12>
                                                        <v-btn outline
                                                               color="#E85353"
                                                               text
                                                               :href="`\${this.rotaCalculadora}`"
                                                               @click="excluirProjeto()">
                                                            EXCLUIR
                                                        </v-btn>
                                                        <v-btn color="#0083CA"
                                                               class="white--text"
                                                               text
                                                               @click="$refs.templatePdfProjectRef.createPDF()">DOWNLOAD</v-btn>
                                                        <v-btn color="#021746"
                                                               class="white--text"
                                                               text
                                                               @click="editarProjeto()">EDITAR</v-btn>
                                                    </v-flex>
                                                    <br />
                                                    <v-divider class="grey lighten-2"></v-divider>
                                                    <v-flex class="text-center" xs12>
                                                        <v-btn outline
                                                               color="#021746"
                                                               @click="listarProjetos()">VOLTAR PARA PROJETOS</v-btn>
                                                    </v-flex>
                                                </v-card-text>
                                            </v-card>
                                        </v-dialog>
                                    </v-layout>
                                </div>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
            </v-content>
            <div hidden>
                <TemplatePdfProjectNewV1 ref="templatePdfProjectRef" hidden />
            </div>
        </v-app>
    </div>
</template>

<script>
    import ProjectBasicCharacteristics from "./ProjectBasicCharacteristics";
    import ListCompatibleGenerators from "./ListCompatibleGenerators";
    import ProjectCommercialInformation from "./ProjectCommerciaInformation";
    import ProjectSummary from "./ProjectSummary";
    import TemplatePdfProjectNewV1 from "./template/TemplatePdfProjectNewV1";

    import { mapActions, mapGetters } from "vuex";
    import ProjectClientData from "./ProjectClientData";
    import axios from "axios";
    import Vue from "vue";

    export default {
        name: "Project",
        components: {
            ProjectClientData,
            ProjectSummary,
            ProjectCommercialInformation,
            ListCompatibleGenerators,
            ProjectBasicCharacteristics,
            TemplatePdfProjectNewV1,
        },
        mounted() {
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning",
                    }).then(() => (location.href = "/login?redirectTo=" + location.href));
                },
            });
        },
        computed: {
            ...mapGetters(["projeto"]),
            step: {
                get() {
                    return this.$store.getters.step;
                },
                set(value) {
                    this.$store.commit("setStep", value);
                },
            },
        },
        data() {
            return {
                dialog: false,
                print: false,
                formContatoValid: false,
            };
        },
        methods: {
            async saveProject() {
                await this.finish();
                if (this.projeto.id == null || this.projeto.id == "") {
                    this.previousStep();
                } else {
                    this.dialog = true;
                }
            },
            validated(value) {
                this.formContatoValid = value;
            },
            validarStep() {
                this.$refs.projectCommercialInformationRef.validate();
                if (this.formContatoValid) this.nextStep();
            },
            ...mapActions(["nextStep", "previousStep", "updateProject", "resetState"]),
            listarProjetos() {
                this.resetState();
                this.$router.push(`${Vue.prototype.$rotaCalculadora}`);
            },
            editarProjeto() {
                var id = this.projeto.id;
                this.resetState();
                this.$router.push(`/calculadora-aldo-solar/editar/${id}`);
            },
            async finish() {
                await axios
                    .post(`${Vue.prototype.$apiUrl}/Projeto.svc/projeto`, this.projeto, {
                        withCredentials: true,
                    })
                    .then((response) => {
                        // console.log(response)
                        this.projeto.id = response.data.Id;
                        // this.updateProject(response.data);
                    })
                    .catch(() => {
                        // console.log(error)
                    });
            },
            excluirProjeto() {
                const self = this;
                this.dialog = true;
                axios
                    .delete(
                        `${Vue.prototype.$apiUrl}Projeto.svc/projeto/${this.projeto.id}`,
                        { withCredentials: true }
                    )
                    .then(() => {
                        self.resetState();
                        self.$router.push(`${Vue.prototype.$rotaCalculadora}`);
                    })
                    .catch(() => {
                        // console.log(error)
                    });
            },
        },
    };
</script>

<style scoped>
    /deep/ .primary-color {
        color: #021746;
    }

    /deep/ .content-grey {
        color: #727272;
    }

    /deep/ .topic {
        font-weight: bold;
        color: #021746;
    }

    /deep/ .primary-text {
        font-weight: bold;
        color: #0083ca;
    }

    /deep/ .generator-description {
        font-weight: normal;
        color: grey;
    }

    /deep/ .card-value {
        font-size: 1.5rem;
        color: #021746;
        font-weight: bold;
    }

    /deep/ .card-info {
        color: #727272;
        font-weight: lighter;
    }

    /deep/ .general-information {
        overflow: auto;
        max-height: 150px;
    }
</style>
